export const RECEIVE_VARIABLE = 'RECEIVE_VARIABLE';
export const KEY_FIRST_LOGIN = 'first_login_web_menu';
